export const isNumNotDefined = (uv: any): boolean =>
  !(uv === undefined || uv === null || uv === '' || isNaN(Number(uv)));
export const isOptionSelected = (uv: any): boolean => {
  // 1. Handle Array case
  if (Array.isArray(uv)) {
    // If array is empty, or first element is '', null, or 0, it's NOT selected
    return uv.length > 0 && uv[0] !== '' && uv[0] !== null && uv[0] !== 0;
  }

  // 2. Handle standard value case
  // Added uv !== 0 to the exclusion list
  return !(
    uv === undefined ||
    uv === null ||
    uv === '' ||
    uv === 0 ||
    isNaN(Number(uv))
  );
};
